// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"c494f05e","101":"89e3d008"}[chunkId] + ".chunk.css";
};